import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface UseWavesSearchProps {
  readonly name: string;
}
export function useWavesSearch(t0) {
  const $ = _c(13);
  const {
    name
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = name.trim();
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const trimmedName = t1;
  let t2;
  let t3;
  if ($[2] !== trimmedName) {
    t2 = [QueryKey.WAVES_SEARCH, {
      name: trimmedName
    }];
    t3 = async () => {
      const params = {
        name: trimmedName,
        limit: "5",
        direct_message: "false"
      };
      return await commonApiFetch({
        endpoint: "waves",
        params
      });
    };
    $[2] = trimmedName;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  const t4 = trimmedName.length >= 2;
  let t5;
  if ($[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t4
    };
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    data: waves
  } = useQuery(t5);
  let t6;
  if ($[9] !== waves) {
    t6 = waves ?? [];
    $[9] = waves;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = {
      waves: t6
    };
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}